import { makeSeoData } from 'config/next-seo.config';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import React from 'react';


// this is to avoid a server-client hydration mismatch.
// GetStarted does a whole lot of client-side management of routing, so we can't really
// expect to know what should be rendered on the server side.
const GetStarted = dynamic(() => import('@components/onboarding/GetStarted'), {
  ssr: false,
});

const title = 'Get a Home Staging Quote from Guest House';
const description = 'Home staging sells homes faster and at premium prices; especially when we stage them with hand picked furniture and décor. Get a home staging quote today.';

export default function GetQuote() {
  const router = useRouter();

  if (!router.isReady) {
    return null;
  }

  return (
    <>
      <Head>
        <title>
          Get a free staging quote | Guest House
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle:title, metaDescription: description })} />

      <GetStarted
        dealID={router.query.dealId?.toString()}
      />
    </>
  );
}
